import React from 'react';

import Icon from 'components/shared/Icon';
import Plane from 'components/shared/Icon/icons/Plane';

import s from '../index.module.css';

export const NoData = () => {
  return (
    <div className={s.noDataContainer}>
      <Icon className={s.icon} component={Plane} />
      <div style={{ fontSize: '18px', lineHeight: '18.4px' }}>Flight Not Found!</div>
      <div>Double check the airline and flight number</div>
    </div>
  );
};
